/**
 * Page Title Component
 * Displays the page title for investor relations pages
 */
import React from 'react'
import styled from '@emotion/styled'

interface PageTitleProps {
  title: string
  narrow?: boolean
}

const TitleWrapper = styled.div<{ narrow?: boolean }>`
  width: ${({ narrow }) => (narrow ? '834px' : 'auto')};
  max-width: ${({ narrow }) => (narrow ? '95%' : '1200px')};
  padding: 2rem ${({ narrow }) => (narrow ? '0' : '2rem')} 1rem;
  margin: 0 auto;

  @media (max-width: 767px) {
    width: 100%;
    max-width: 100%;
    padding: 2rem 1.25rem 1rem;
  }
`

const Title = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 112px;
  height: 45px;
  padding: 0 16px;
  border-radius: 4px 4px 0 0;
  background: #ff6637;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
`

const TitleRule = styled.div`
  height: 1px;
  background: #ff6637;
`

const PageTitle: React.FC<PageTitleProps> = ({ title, narrow = false }) => {
  return (
    <TitleWrapper narrow={narrow}>
      <Title>{title}</Title>
      <TitleRule />
    </TitleWrapper>
  )
}

export default PageTitle